import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@apollo/client'

import { CurrentLegalFormalityContext } from 'contexts/LegalFormalityContext'
import { EDIT_FORMALITY_FLOW_MUTATION } from 'graphql/LegalFormalities'
import FormalityStepButton from './FormalityStepButton'

const FormalityRollbackBtn = () => {
  const { t } = useTranslation('legalFormalities')
  const { legalFormality, legalFormalityRefetch, setCurrentTab } = useContext(
    CurrentLegalFormalityContext
  )
  const [rollbackFormality] = useMutation(EDIT_FORMALITY_FLOW_MUTATION)

  if (!legalFormality.isRollbackable) {
    return <></>
  }

  const handleRollback = () => {
    rollbackFormality({
      variables: { id: legalFormality.id, rollback: true },
    })
      .then(r => {
        setCurrentTab('form')
        legalFormalityRefetch()
      })
      .catch(e => {
        console.error(e)
      })
  }

  return (
    <FormalityStepButton
      title={t('show.form.submit.confirm.rollback.title')}
      description={t('show.form.submit.confirm.rollback.description')}
      buttonLabel={t('show.form.submit.confirm.rollback.label')}
      onConfirm={handleRollback}
      danger={true}
    />
  )
}

export default FormalityRollbackBtn
